import styled from 'styled-components'

export const SliderContainer = styled.div`
  position: relative;
`
